export const labelStyle = {
  display: "block",
  fontSize: "0.72rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  color: "#9e9e9e",
  marginBottom: "5px",
};

export const inputStyle = {
  width: "100%",
  border: "1px solid #e0e0e0",
  borderRadius: "8px",
  padding: "9px 12px",
  fontSize: "0.9rem",
  color: "#212121",
  background: "#fff",
  outline: "none",
  transition: "border-color 0.15s, box-shadow 0.15s",
};

export const groupStyle = {
  marginBottom: "4px",
  display: "flex",
  flexDirection: "column",
};

export const focusStyle = `
  .field-modern:focus {
    border-color: #1a73e8 !important;
    box-shadow: 0 0 0 3px rgba(26,115,232,0.15) !important;
    outline: none !important;
  }
  .field-modern {
    border: 1px solid #e0e0e0 !important;
    border-radius: 8px !important;
    padding: 9px 12px !important;
    font-size: 0.9rem !important;
    color: #212121 !important;
    background: #fff !important;
    transition: border-color 0.15s, box-shadow 0.15s !important;
  }
  .field-modern.is-invalid {
    border-color: #c62828 !important;
  }
`;
